module.exports = __webpack_public_path__ + "static/media/three-presentations.518a470e.png";